import { normalize } from 'normalizr';
import { arrayOfVideos } from 'shared/schemas';

import createAsyncActions from 'shared/redux/helpers/create-async-actions';
import vodAdapter from 'shared/utils/adapters/vod';


const ACTIONS = createAsyncActions('SERVER.VIDEOS.SEARCH');
export const NAMES = ACTIONS.NAMES;
const { START, SUCCESS, FAIL } = ACTIONS;


export default function search(query, options) {

  options = {
    ...options,
    paging: { size: 1000 },
  };

  return function (dispatch) {
    const params = { query };
    dispatch(START(params));

    const promise = vodAdapter.items.search(query, options);

    return promise
      .then(
        function (response) {
          response = {
            ...response,
            data: normalize(response.data, arrayOfVideos),
          };

          dispatch(SUCCESS(params, response));
          return response;
        },

        function (response) {
          dispatch(FAIL(params, response, { analytics: { type: 'error', name: 'dashboard.videos.search' } }));
        }
      );
  };

}



// WEBPACK FOOTER //
// ./src/dashboard/redux/server/actions/videos/search.js